import "./ChatItem.scss";
import dayjs from "dayjs";
import { useNavigate } from "react-router";
import modelDescriptors, {
  currentModelDescriptions,
} from "../../../../../model/model-providers/modelDescriptors";

import { shortenName } from "./nameUtils";
import { linkToNewChat } from "../../../../../routes";
import { useParams } from "react-router-dom";
import { MessageSquareTextIcon, BotIcon } from "lucide-react";
import LogoOpenAI from "../../../../../assets/icons/LogoOpenAI";
import LogoClaude from "../../../../../assets/icons/LogoClaude";
import ModelVendors from "../../../../../model/model-providers/modelVendors";
import NebiusChatAvatar from "../../details/NebiusChatAvatar";

const ChatItem = ({ chat }) => {
  const nav = useNavigate();
  const { workspaceId } = useParams();
  const model = currentModelDescriptions.find(
    (item) => item.id === chat.modelId
  );
  const oldNodel = modelDescriptors.find((item) => item.id === chat.modelId);

  const vendor = model?.vendor || oldNodel?.vendor;

  const renderIcon = () => {
    if (vendor === ModelVendors.OPENAI) {
      return <LogoOpenAI size={36} />;
    } else if (vendor === ModelVendors.ANTHROPIC) {
      return <LogoClaude size={36} />;
    } else if (vendor === ModelVendors.NEBIUS) {
      return (
        <NebiusChatAvatar
          modelId={chat.modelId}
          size={36}
          color="rgb(145,155,173)"
        />
      );
    } else {
      return (
        <MessageSquareTextIcon
          color="rgb(145,155,173)"
          size={36}
          strokeWidth="1.5"
        />
      );
    }
  };

  return (
    <div
      className="chat_list_item chat_chat_item"
      onClick={() => nav(linkToNewChat(workspaceId, chat.uid))}
    >
      <div className="item_icon">
        {chat.assistantUid && (
          <BotIcon color="#344767" size={36} strokeWidth="1.5" />
        )}
        {renderIcon()}
      </div>
      <div className="item_name">{shortenName(chat.name)}</div>
      <div className="model_name">
        {model?.name}
        {!model && oldNodel?.name}
      </div>
      <div className="item_date">{dayjs(chat.dateUpdated).fromNow()}</div>
    </div>
  );
};

export default ChatItem;
